import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { RoamdocJobPost } from "#/db/schema";
import type { PageMetadata } from "#/lib/seo";
import type { HiringOrg } from "#/types/types";

export type JobPostingPageData = {
  metadata: PageMetadata;
  posting: RoamdocJobPost;
  hiringOrg: HiringOrg | null;
  similarJobs: RoamdocJobPost[];
  jsonLd: string | null;
  canonicalPath: string;
};

export const loadJobPostingPageData = createServerFn({ method: "GET" })
  .inputValidator(
    z.object({
      slugWithIdentifier: z.string().min(1),
    }),
  )
  .handler(async ({ data }) => {
    const { getJobPostingPageData } = await import("./job-posting.server");

    return getJobPostingPageData(data.slugWithIdentifier);
  });
